var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnelAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84492 8.53258L8.78934 13.5086C8.92587 13.6809 8.99999 13.8928 8.99999 14.111V21.0175C8.99999 21.7469 9.7823 22.2213 10.4472 21.8951L14.4472 19.9328C14.786 19.7665 15 19.4268 15 19.0551V14.111C15 13.8928 15.0741 13.6809 15.2106 13.5086L19.1551 8.53258C17.2133 9.05676 14.7015 9.35898 12 9.35898C9.29853 9.35898 6.78671 9.05676 4.84492 8.53258Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9651 6.24914C19.3306 7.21985 15.93 7.88718 12 7.88718C8.06997 7.88718 4.66945 7.21985 3.03488 6.24914C3.01845 6.23938 3.00219 6.22958 2.98611 6.21976C2.35415 5.8337 2 5.40082 2 4.94359C2 3.31789 6.47715 2 12 2C17.5228 2 22 3.31789 22 4.94359C22 5.41245 21.6276 5.85571 20.9651 6.24914Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelAlt1);
export default __webpack_public_path__ + "static/media/funnel-alt-1.f25f5baa383c6695f908a34cce48ebfc.svg";
export { ForwardRef as ReactComponent };